/* src/app/home-new/file-segment-options/file-segment-options.component.scss */
.segment-options {
  margin: 10px 0;
}
.segment-options ion-label {
  line-height: 10px;
  font-size: 10px;
  margin: 4px;
}
.segment-options .segment-button-checked {
  background-color: var(--ion-color-primary) !important;
  color: var(--ion-color-primary);
  font-weight: 600;
}
ion-label {
  margin: 0 !important;
}
/*# sourceMappingURL=file-segment-options.component-M5ERG74V.css.map */
